import { ShowCaseGame } from './ShowcaseGame.js';
import './css/App.css';
import rental1 from './assets/rental1.jpg';
import rental2 from './assets/rental2.jpg';
import rental3 from './assets/rental3.jpg';
import rental4 from './assets/rental4.jpg';
import rental5 from './assets/rental5.jpg';

function RentalView() {

  const description = "Rental is a short and spooky adventure game about the dangers of renting a house in an unknown place.";
  var displayImages = [rental1, rental2, rental3, rental4, rental5];

  return (
    <div className="App" style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100vh',
      zIndex: -1
    }}>
      <ShowCaseGame 
        title1="RENTAL"
        title2="AVAILABLE NOW!"
        title1Color="rental"
        displayImages={displayImages}
        description={description}
        linkedButtonText="Play on Steam"
        steamLink="https://store.steampowered.com/app/2796550/Rental/"
        presskitLink="https://drive.google.com/drive/folders/1qUWfKLIFkmj6uyGn6CFqooWccUYA8Sl1"
      />
    </div>
  );
}

export default RentalView;
